import styled from '@emotion/styled';
import { Variables } from '../../base';
import { DataTable } from '../../data-table';

export const TableCard = styled.div`
    background: ${Variables.Swatches.White};
    border: 1px solid ${Variables.ThemeLight.Border1};
    border-radius: 8px;
    box-shadow: 0 1px 2px ${Variables.Colors.nx4};
    overflow: hidden;
`;

export const StyledDataTable = styled(DataTable)`
    margin: 0;

    /* Keep header and body on the same full-width flex row track */
    [role='row'] {
        display: flex !important;
        width: 100% !important;
        min-width: 100% !important;
        max-width: none !important;
        box-sizing: border-box;
        border-bottom: 1px solid ${Variables.ThemeLight.Border1};

        &:last-child {
            border-bottom: none;
        }
    }

    [role='columnheader'],
    [role='cell'] {
        box-sizing: border-box !important;
        flex-shrink: 1 !important;
        border-right: none;
        overflow: hidden;
    }

    [role='columnheader'] {
        display: flex;
        align-items: center;
        padding: 11px 20px;
        background: ${Variables.Colors.n15_24};
        border-bottom: 1px solid ${Variables.ThemeLight.Border1};
        font-size: 12px;
        font-weight: 600;
        line-height: 1.3;
        color: ${Variables.Colors.n70};
        text-transform: uppercase;
        letter-spacing: 0.03em;
        cursor: default !important;

        &:hover {
            color: ${Variables.Colors.n70} !important;
        }

        .sort-indicator,
        .sort-indicator-container,
        .resizer {
            display: none !important;
        }
    }

    [role='cell'] {
        display: flex;
        align-items: center;
        padding: 14px 20px;
        font-size: 14px;
        line-height: 1.4;
        color: ${Variables.Colors.n100};
        white-space: normal;
        text-overflow: unset;
    }
`;

export const HeaderCell = styled.div<{ align?: 'left' | 'right' }>`
    width: 100%;
    text-align: ${props => props.align || 'left'};
`;

export const BodyCell = styled.div<{ align?: 'left' | 'right' }>`
    width: 100%;
    text-align: ${props => props.align || 'left'};
`;

export const Empty = styled.div`
    padding: 48px 20px;
    text-align: center;
    background: ${Variables.Swatches.White};
    border: 1px dashed ${Variables.ThemeLight.Border1};
    border-radius: 12px;
    color: ${Variables.Colors.n70};
    font-size: 14px;
`;
